import { bannerModalPermission } from 'constants/teams-and-members';

import { ReactComponent as WalletIcon } from 'assets/images/Components_Icons_wallet.svg';
import { ReactComponent as FinanceIcon } from 'assets/images/Components_Icons_cash.svg';
import { ReactComponent as IntegrationsIcon } from 'assets/images/Components_Icons_puzzle.svg';
import { ReactComponent as BusinessIcon } from 'assets/images/settings_teams_and_members.svg';

const rolesCodes = [
  { icon: FinanceIcon, code: 108 },
  { icon: WalletIcon, code: 104 },
  { icon: IntegrationsIcon, code: 101 },
  { icon: BusinessIcon, code: 102 },
  { icon: FinanceIcon, code: 208 },
  { icon: WalletIcon, code: 204 },
  { icon: IntegrationsIcon, code: 201 },
  { icon: BusinessIcon, code: 202 }
];

export const mapCodeToIcons = (code) => {
  return Object.values(rolesCodes).find((item) => item.code === code)?.icon;
};

export const checkRoleBannerModal = (type) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  return bannerModalPermission[type].includes(userInfo.user?.group?.name);
};
